import { COLORS } from "../../../../constants";
export var getOptionStyles = function (size) { return ({
    "&.MuiAutocomplete-option": {
        alignItems: "center",
        height: size === "medium" ? "42px" : size === "large" ? "44px" : "40px",
        py: 0,
        borderRadius: 2,
    },
    "&.MuiAutocomplete-option.MuiAutocomplete-option.Mui-focused": {
        backgroundColor: COLORS.SECONDARY_HOVER,
    },
    "&.MuiAutocomplete-option.MuiAutocomplete-option:active": {
        backgroundColor: COLORS.SECONDARY_PRESSED,
    },
    '&.MuiAutocomplete-option[aria-selected="true"]': {
        backgroundColor: "transparent",
    },
}); };
